'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Housecall = function Housecall(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("polygon", {
    points: "15,19.4 16.3,19.4 16.4,4.9 15,4.9 15,3.2 18.1,3.2 18,21.1 15,21.1 "
  }), React__default["default"].createElement("polygon", {
    points: "5.9,4.9 13,0.8 13,3.3 13,5.5 13,18.9 13,21.2 13,23.2 5.9,19.4 "
  }), React__default["default"].createElement("polygon", {
    points: "13,21.2 13,18.9 13,5.5 13,3.3 13,0.8 5.9,4.9 5.9,19.4 13,23.2 "
  }), React__default["default"].createElement("polygon", {
    points: "18.1,3.2 15,3.2 15,4.9 16.4,4.9 16.3,19.4 15,19.4 15,21.1 18,21.1 "
  }));
};

var Housecall$1 = iconStyles()(Housecall);

module.exports = Housecall$1;
